import { Outlet, Route, Routes } from "react-router-dom";
import Tournaments from "../pages/tournaments";
import TouranamentList from "../pages/tournametList";
import Match from "../pages/matchCard";
import SingleMatch from "../pages/matchCard";

export const Routers = () => {
  const port = process.env.PORT || 3000;

  return (
    <Routes>
      <Route path="/" element={<TouranamentList />} />
      <Route path=":tournament_slug" element={<Tournaments />} />
      <Route path=":tournament_slug/matches/:matchuuid" element={<SingleMatch />} />
    </Routes>
  );
};
